<template>
  <div class="trainer-unbound bottom-padding">
    <div class="guide-img"/>
    <weui-group>
      <weui-cell label="姓名" :text="trainer.name" tips="未绑定" />
      <weui-cell label="备注" :text="trainer.name_remarks" />
    </weui-group>
    <weui-group>
      <weui-cell :link="true" label="剩余课程" :tips="`${ Math.max(trainer.course_count - trainer.closed_course_count, 0) } 节`" @click="changeCourseCount" />
      <weui-cell label="总完成课程" :tips="`${ trainer.closed_course_count } 节`" />
      <weui-cell v-for="stat in trainer_course_monthly_stats" :key="stat.month" v-if="stat.closed_course_count" :label="`${getMonth(stat.month)}月完成课程`" :tips="`${stat.closed_course_count} 节`" />
    </weui-group>
    <weui-button-area>
      <weui-button type="default" @click="changeNickname">修改备注名</weui-button>
      <weui-button type="default" @click="goback">返回列表</weui-button>
    </weui-button-area>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import weui from '@/wechat/weui';
import { WeuiGroup, WeuiCell, WeuiButtonArea, WeuiButton } from '@/components/weui';
import mixinDatetime from '@/mixins/datetime';

import { ROUTE_TRAINER_NICKNAME } from '@/router/names';
import { FETCH_TRAINER_COURSE_MONTHLY_STATS, PATCH_TRAINER } from '@/store/trainer/types';

const { mapState, mapActions } = createNamespacedHelpers('trainer');

export default {
    props: {
        trainer: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            id: 0,
        };
    },
    computed: {
        ...mapState({
            trainer_course_monthly_stats: state => state.trainer_course_monthly_stats || [],
            patched: state => state.patched || {},
        }),
    },
    created() {
        const { id } = this.$route.params;
        this.id = id;
        this.fetchTrainerCourseMonthlyStats({ id });
    },
    methods: {
        ...mapActions({
            fetchTrainerCourseMonthlyStats: FETCH_TRAINER_COURSE_MONTHLY_STATS,
            patchTrainer: PATCH_TRAINER,
        }),
        changeNickname() {
            const { id } = this.trainer;
            this.$router.push({
                name: ROUTE_TRAINER_NICKNAME,
                params: {
                    id,
                },
            });
        },
        async changeCourseCount() {
            const options = [];
            for (let i = 1; i < 90; i += 1) {
                options.push({
                    label: i,
                    value: i,
                });
            }
            const result = await weui.picker(options, {
                defaultValue: [Math.max(this.trainer.course_count - this.trainer.closed_course_count, 0)],
            });
            if (!result) {
                return;
            }
            const value = result[0].valueOf();

            await this.patchTrainer({
                trainer: {
                    id: this.id,
                    course_count: this.trainer.closed_course_count + value,
                },
            });

            weui.toast('已设置剩余课程');
            this.trainer.course_count = this.patched.course_count;
        },
        goback() {
            this.$router.go(-1);
        },
    },
    mixins: [
        mixinDatetime,
    ],
    components: {
        WeuiGroup,
        WeuiCell,
        WeuiButtonArea,
        WeuiButton,
    },
};
</script>

<style lang="scss" scoped>
.guide-img {
    height: 60vw;
    background-image: url(../../assets/images/share-trainer.png);
    background-size: cover;
    margin-bottom: 12vw;
}
</style>



// WEBPACK FOOTER //
// src/components/trainer/UnboundView.vue